import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/_current/environment';
import { AaptivRoles } from '@skyfit/core-data-library';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminInviteUserService {
  private readonly http = inject(HttpClient);

  inviteUser(
    email: string,
    tenantId: string,
    admin = false,
    firstName?: string,
    lastName?: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<any> {
    const url = `${environment.aaptivServiceUrl}/api/v1/enterpriseTenants/${tenantId}/invite`;

    const params: {
      email: string;
      admin: boolean;
      firstName?: string;
      lastName?: string;
    } = {
      email,
      admin,
    };

    if (firstName) {
      params.firstName = firstName;
    }

    if (lastName) {
      params.lastName = lastName;
    }

    return this.http.post(url, params);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getInviteInfo(authCode: string): Observable<any> {
    const url = `${environment.aaptivServiceUrl}/api/v1/enterpriseUserGroupUserAuthorization/${authCode}`;
    return this.http.get(url);
  }

  //No auth required for creating new user
  createNewAdminUser(
    authCode: string,
    tenantId: string,
    email: string,
    password: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<any> {
    const url = `${environment.aaptivServiceUrl}/api/v1/user/${tenantId}/${authCode}`;
    return this.http.post(url, {
      email,
      password,
      roles: [AaptivRoles.admin],
    });
  }
}
